export const dataHooks = {
    baseCalendar: 'baseCalendarHook',
};
//# sourceMappingURL=constants.js.map